import PropTypes from 'prop-types';
import React, { Component, useState } from 'react';
import Dropzone from 'react-dropzone';

import { Trash } from 'lucide-react';
import { Button, Thumbnail, DefaultPopover, DefaultTooltip } from 'twyne-new.ui'

import HttpClient from 'utils/httpclient';

class ImageField extends Component {
  
  state = {
    active: true,
    featured_image: null,
    isLoadImage: false,
    imageName: null
  }

  componentDidMount () {

    const value = this.props.value || null

    if(value){
      this.setState({
        featured_image: value.src,
        imageName: value.name
      })
    }
  }

  componentWillReceiveProps(props) {

    const value = props.value || null

    if(value){
      this.setState({
        featured_image: value.src,
        imageName: value.name
      })
    }
  }

  handleImageChange = (src, name) => {
    
    this.props.onChange({
      value: {
        src,
        name
      }
    })
  }

  handleImageUpload = (file) => {
    this.setState({
      isLoadImage: true
    }, () => {
      this.submitImage(file).then(file => {
        this.setState({
          featured_image: file.location,
          imageName: file.originalname
        })
        this.handleImageChange(file.location, file.originalname)
      }).catch(response => {
        this.handleImageRemove()
      }).finally(response => 
        this.setState({isLoadImage: false}))
        
    })
  };

  formatImageName = name => {
    if (!name) {
      return ''
    }

    const lastDotIndex = name.lastIndexOf('.')
    if (lastDotIndex === -1) {
      return name
    }

    const extension = name.slice(lastDotIndex)
    const nameWithoutExt = name.slice(0, lastDotIndex)

    if (nameWithoutExt.length <= 15) {
      return name
    }

    return <>
      <DefaultTooltip content={name}>
        {nameWithoutExt.slice(0, 15)}(...){extension}
      </DefaultTooltip>
    </>
  }

  submitImage = (file) => {
    let data = new FormData();
    data.append('image', file);

    return (
      HttpClient.post(`/api/cms/image`, data)
      .then((response) => {
        return response.data;
      })
    );
  }

  handleImageRemove = () => {
    this.setState({ featured_image: null, imageName: null })
    this.handleImageChange(undefined, undefined)
  }

  render() {
    const featuredImage = this.state.featured_image

    return (
      <div className='flex flex-col w-full relative'>
        <HoverPopover id={this.state.imageName} popoverContent={<img src={this.state.featured_image} alt="feature_image" width="100%" className='p-2 w-full' />}>
          <Dropzone
            multiple={false}
            accept="image/*"
            onDrop={files => this.handleImageUpload(files[0])}
            style={{}}
          >
            <Thumbnail
              value={featuredImage}
              size='lg'
              isLoading={this.state.isLoadImage}
              type='image'
            />
          </Dropzone>
        </HoverPopover>
        {featuredImage && featuredImage.length ? <>
          <div className='font-bold mt-1'>{this.formatImageName(this.state.imageName)}</div>
          <Button
            className='absolute top-0 right-0'
            color="danger"
            variant='ghost' size="sm" onClick={this.handleImageRemove}>
            <Trash size={14} />
          </Button>
        </> : null}
      </div>
    )
  }
}

function HoverPopover({ children, popoverContent, id }) {
  const [open, setOpen] = useState(false)
  const toggle = open => () => setOpen(open)

  if (!id) return children

  return <div onMouseEnter={toggle(true)} onMouseLeave={toggle(false)} className='w-full'>
    <DefaultPopover
      trigger={children}
      triggerProps={{ asChild: true }}
      wrapperProps={{ open }}
      contentProps={{ className: 'p-0!' }}
    >
      {popoverContent}
    </DefaultPopover>
  </div>
}

ImageField.propTypes = {
  value: PropTypes.any
}

export default ImageField;
